import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  HomeIcon,
  DocumentTextIcon,
  CubeIcon,
  FolderIcon,
  PhotoIcon,
  SwatchIcon,
} from '@heroicons/react/24/outline';

const AdminSidebar = () => {
  const location = useLocation();

  const navigation = [
    { name: 'Dashboard', href: '/admin/dashboard', icon: HomeIcon },
    { name: 'Bloglar', href: '/admin/blogs', icon: DocumentTextIcon },
    { name: 'Ürünler', href: '/admin/products', icon: CubeIcon },
    { name: 'Projeler', href: '/admin/projects', icon: FolderIcon },
    { name: 'Galeri', href: '/admin/gallery', icon: PhotoIcon },
    { name: 'Renkler', href: '/admin/colors', icon: SwatchIcon },
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div className="w-64 bg-white shadow-lg min-h-screen">
      <nav className="mt-5 px-2">
        <div className="space-y-1">
          {navigation.map((item) => (
            <div key={item.name}>
              <Link
                to={item.href}
                className={`${
                  isActive(item.href)
                    ? 'bg-[#dbc582] text-white'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                } group flex items-center px-2 py-2 text-base font-medium rounded-md`}
              >
                <item.icon
                  className={`${
                    isActive(item.href)
                      ? 'text-white'
                      : 'text-gray-400 group-hover:text-gray-500'
                  } mr-4 flex-shrink-0 h-6 w-6`}
                  aria-hidden="true"
                />
                {item.name}
              </Link>
            </div>
          ))}
        </div>
      </nav>
    </div>
  );
};

export default AdminSidebar;
